module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-select-dropdown el-popper",
    class: [{
      'is-multiple': _vm.$parent.multiple
    }, _vm.popperClass],
    style: ({
      minWidth: _vm.minWidth
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19677152"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/select/src/select-dropdown.vue
// module id = 2026
// module chunks = 228